import type { CodexEntryView, CodexFamilyView } from '@aztec-realms/shared-types';
import { codexFamilyIllustration, codexIllustration } from './codex-presentation';
import { generatedRuntimeAssetManifest } from './game/asset-manifest';
import './codex-art.css';

/** Shared family art across navigation, earned cards, reader and mastery. Never grants discovery. */
export function CodexGlyph({
  family,
  entry,
  familyOnly = false,
}: {
  family: CodexFamilyView;
  entry: CodexEntryView;
  familyOnly?: boolean;
}) {
  const art = familyOnly ? codexFamilyIllustration(family.id) : codexIllustration(entry);
  return (
    <span
      aria-hidden="true"
      className="codex-glyph-art"
      data-family={family.id}
      data-status={familyOnly ? 'family' : entry.status}
      data-artwork={art?.id ?? 'sealed'}
    >
      {art ? (
        <img alt="" src={art.url} width={256} height={256} decoding="async" />
      ) : (
        <span className="codex-glyph-art__sealed">
          <img
            alt=""
            src={generatedRuntimeAssetManifest.decodeLimestoneSurface.url}
            width={256}
            height={256}
            decoding="async"
          />
          <span>{entry.status === 'found' ? '◇' : '?'}</span>
        </span>
      )}
    </span>
  );
}
